import moment from "moment";

export const defaultTransformer = (value: any) => value;

/**
 * 
 * @param key the column from a table dataset
 * @returns 
 */
const setType = (key: string) => (value: any) => {
  // If this switch starts getting large, consider injecting the special cases
  switch(key) {
    case 'requestCreated':
      return moment(value.requestCreated).unix();
    case 'planName.name':
      return value.planName.name;
      case 'loanName.name':
        return value.loanName.name;
    default:
      return value[key];
  }
};


/**
 * This function is designed to update the sort direction of a column when using the Table component
 * 
 * This is to be used in a onSortChange function
 * 
 * @param key The columne from a table dataset
 * @param sortDirection 
 * @returns 
 */
export const sortRecord = (key: string, sortDirection: 'asc' | 'desc', transformer) => {
  const cast = setType(key);

  return (a, b) => {
    // values need to be primitive types for comparison to work correctly
    const valueA = cast(transformer(a));
    const valueB = cast(transformer(b));
    if (valueA === valueB) {
      return 0;
    }
    if (sortDirection === 'asc') {
      return valueA > valueB ? 1 : -1;
    } else {
      return valueA < valueB ? 1 : -1;
    }
  };
};
